module.exports = __webpack_public_path__ + "static/media/table-grey-9-ball.1880d938.png";